import { FormattedMessage, useIntl } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const MobileDeviceManagement = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.mdm.title",
            defaultMessage: "MDM (Mobile Device Management)"
        }),
        body: intl.formatMessage({
            id: "ConfluencePricingPage.modal-content.mdm.body",
            defaultMessage:
                "Enforce security controls on mobile app usage through built-in mobile device management (MDM) support for iOS and Android."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
            <div>
                <FormattedMessage
                    id="ConfluencePricingPage.modal-content.mdm.cta"
                    defaultMessage="<a>Learn more</a> about MDM."
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks: React.ReactNode) => (
                            <a
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={`https://support.atlassian.com${useLocalizedHref(
                                    "/security-and-access-policies/docs/mobile-device-management-mdm-for-atlassian-mobile-apps/"
                                )}`}
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-track-event="ConfluencePricingPage.mobileDeviceManagement"
                                data-event-container="ConfluencePricingPage"
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </div>
        </div>
    );
};

export default MobileDeviceManagement;
